import React from 'react';
import Skeleton from '@mui/material/Skeleton';
import { styled } from '@mui/material/styles';
import { useWidget } from '@guest-widgets/core';

export const FiltersSkeleton = () => {
  const { widgetArea } = useWidget();
  return widgetArea.isLarge ? (
    <FilterSkeleton>
      <FilterSkeletonLeft>
        <Skeleton variant="rectangular" width={200} height={30} />
        <Skeleton variant="rectangular" width={150} height={30} />
        <Skeleton variant="rectangular" width={100} height={30} />
      </FilterSkeletonLeft>
      <Skeleton variant="rectangular" width={80} height={30} />
    </FilterSkeleton>
  ) : (
    <Skeleton variant="rectangular" width={100} height={30} />
  );
};

const FilterSkeleton = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  marginTop: theme.spacing(2),
}));

const FilterSkeletonLeft = styled('div')(({ theme }) => ({
  display: 'flex',

  '& > *': {
    marginRight: theme.spacing(2),
  },
}));
